import { client, useConfig, useElementData } from '@sigmacomputing/plugin'
import { useEffect } from 'react'
import { themeOptions, themes, formatTypes } from '../utilities'
import '../data-viz/components/SimpleMetric'
  
export default function Card() {

    useEffect(() => {
        client.config.configureEditorPanel([
            {
                name: "source",
                type: "element",
            },
            {
                name: "value",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: 'label',
                type: 'text',
                secure: false, 
                multiline: false, 
                placeholder: '',
                defaultValue: ''
            },
            {
                name: 'theme',
                type: 'dropdown',
                values: themeOptions
            },
            {
                name: 'format',
                type: 'dropdown',
                values: formatTypes
            },
            {
                name: "historyValues",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: "historyLabels",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: 'helpText',
                type: 'text',
                secure: false, 
                multiline: false, 
                placeholder: '',
                defaultValue: ''
            }
        ])
    }, [])
        
    const config = useConfig()
    const sigmaData = useElementData(config.source)

    const { value, label, theme, format, helpText, historyValues, historyLabels } = config
    const val = (Object.keys(sigmaData).length && value) ? sigmaData[value][0] : null
    const historyVals = (Object.keys(sigmaData).length && historyValues) ? sigmaData[historyValues] : []
    const historyLabs = (Object.keys(sigmaData).length && historyLabels) ? sigmaData[historyLabels] : []

    return (
        <>
            <zero-simple-metric
                data-fill={themes[theme]?.dark}
                data-bg={themes[theme]?.light}
                data-value={val}
                data-label={label}
                data-format={format}
                data-help={helpText}
                data-history={historyVals}
                data-history-labels={historyLabs}></zero-simple-metric>
        </>
    )
}
